import { request } from './request';
import { getUserId } from './user.service';

export async function getDocumentDetails(
  abortController = null,
  handleErrorResponse = null,
  showToastOnError = true,
  suppressTealiumEvent = false,
) {
  const userId = getUserId();
  const res = await request(
    `documents?userReference=${userId}`,
    {
      fetchOptions: {
        method: 'GET',
        signal: abortController?.signal || null,
      },
    },
    null,
    null,
    showToastOnError,
    true,
  );

  const isAborted = !!abortController && abortController?.signal?.aborted;
  if (res?.status === 200 && Object.keys(res.result).length > 0) {
    return res.result;
  } else if (handleErrorResponse && !isAborted) {
    handleErrorResponse(
      'error response from the documents GET endpoint',
      true,
      suppressTealiumEvent,
      res,
    );
  }
}

export async function getDocument(
  documentId,
  abortController = null,
  handleErrorResponse = null,
  showToastOnError = true,
  suppressTealiumEvent = false,
) {
  const userId = getUserId();
  const res = await request(
    `retrieve?userReference=${userId}&documentId=${documentId}`,
    {
      fetchOptions: {
        method: 'GET',
        signal: abortController?.signal || null,
      },
    },
    null,
    null,
    showToastOnError,
    true,
  );

  const isAborted = !!abortController && abortController?.signal?.aborted;
  if (res?.status === 200) {
    return res.result;
  } else if (handleErrorResponse && isAborted) {
    handleErrorResponse(
      'error response from the documents retrieve GET endpoint',
      true,
      suppressTealiumEvent,
      res,
    );
  }
}
